import { clsx } from 'clsx/lite';
import styles from './BackgroundGradient.module.css';
import backgroundStyles from './backgrounds.module.css';
import desktopBackgroundStyles from './backgrounds-desktop.module.css';
import tabletBackgroundStyles from './backgrounds-tablet.module.css';

export type AllowedBackgroundGradients = keyof Omit<typeof backgroundStyles, 'none'>;

interface BackgroundGradientProps {
  backgroundGradient?: AllowedBackgroundGradients;
  overlayGrid?: boolean;
  children: React.ReactNode;
  className?: string;
  gridAnchor?: 'bottom' | 'top';
  backgroundClass?: string;
  pinTo?: 'desktop' | 'tablet';
  overrideGridSize?: number;
}

const BackgroundGradient: React.FC<BackgroundGradientProps> = (props) => {
  const {
    backgroundGradient,
    overlayGrid,
    children,
    className,
    gridAnchor = 'top',
    backgroundClass,
    pinTo,
    overrideGridSize,
  } = props;

  if (!backgroundGradient) {
    return null;
  }

  const wrapperStyle: React.CSSProperties = {};
  if (overrideGridSize) {
    (wrapperStyle as any)['--background-gradient-override-grid-size'] = `${overrideGridSize}px`;
  }

  return (
    <div style={wrapperStyle} className={clsx(styles.backgroundWrapper, className)}>
      <div
        className={clsx(
          styles.backgroundImage,
          !pinTo && backgroundStyles[backgroundGradient],
          pinTo === 'desktop' && desktopBackgroundStyles[backgroundGradient],
          pinTo === 'tablet' && tabletBackgroundStyles[backgroundGradient],
          backgroundClass
        )}
      />
      {overlayGrid && <div className={clsx(styles.grid, styles[gridAnchor])} />}
      {children}
    </div>
  );
};

export default BackgroundGradient;
